<template>
  <div class="product-add">

    <el-form size="small" ref="formData" :model="formData" label-width="200px">
      
      <el-form-item label="分享文章得积分" prop="share_article_point">
        <el-input type='number' v-model="formData.share_article_point" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div>
        <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ArticleApi from '@/api/article.js';
export default {
  data() {
    return {
      /*form表单数据*/
      formData: {
        share_article_point: 0,
      }
    };
  },
  created() {
    this.getData();
  },

  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      ArticleApi.settingDetail({}, true)
        .then(data => {
          if(data.data.values!=[]){
            console.log(data.data.values);
             self.formData = data.data.values;
          }
         
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      ArticleApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/article/setting/setting.vue